import { KEYBOARD_OPEN_CLASS } from 'utils/native/native.constants';

export const SPACING_SM = 4;
export const SPACING_LG = 6;
export const SPACING_XS = 2;
export const DEFAULT_LOGIN_HEADER = 'Optimus Login';

// When the native software keyboard is open the WebView shrinks; compact the login card (smaller
// logo, tighter spacing, no pinned footer overlay) and top-align it under the safe area so the
// username, password, and submit button all fit above the keyboard without depending on scrolling.
// Scoped to the keyboard-open class — set only on native — so the web login is unaffected.
export const KEYBOARD_OPEN_SELECTOR = `.${KEYBOARD_OPEN_CLASS} &`;
export const COMPACT_LOGO_MAX_HEIGHT = 48;

// DEV-4179: query params the backend embeds in the invite activation email link
// (?requestId=<id>&code=<code>). Detected on login mount to auto-drive the
// OTP-confirm → set-password activation flow without any user interaction.
export const ACTIVATION_REQUEST_ID_QUERY_PARAM = 'requestId';
export const ACTIVATION_CODE_QUERY_PARAM = 'code';

export const BACK_TO_PASSWORD_LABEL = 'Back to password sign-in';

export const USE_PASSWORD_TO_SIGN_IN_MESSAGE =
  'This account has a password. Use your password to sign in.';
